<div class="invite-user" [formGroup]="inviteUserFormGroup">
  <app-popup-top-line></app-popup-top-line>
  <div class="invite-user-header">
    <div class="title">
      {{ 'userManagementPage.usersPage.inviteUserTitle' | labelsProvider }}
    </div>
    <img style="cursor: pointer" src="assets/images/common/cancel.svg" (click)="onClose()" />
  </div>
  <div class="invite-user-body">
    <div class="invite-user-field">
      <div class="input-title">
        {{ 'userManagementPage.usersPage.inviteUserEmailTitle' | labelsProvider }}
      </div>
      <div class="input">
        <input
          [placeholder]="'userManagementPage.usersPage.inviteUserEmailPlaceholder' | labelsProvider"
          type="text"
          formControlName="userEmail"
        />
      </div>
    </div>

    <div class="invite-user-field">
      <div class="input-title">
        {{ 'userManagementPage.usersPage.inviteUserRoleTitle' | labelsProvider }}
      </div>

      <div class="drop-down-field">
        <app-select
          class="role-field-box"
          [placeHolder]="'userManagementPage.usersPage.inviteUserRolePlaceholder' | labelsProvider"
          [options]="roles"
          (optionOnSelection)="onRoleSelection($event)"
          [useBeutifyStringProviderPipe]="true"
        >
        </app-select>
      </div>
    </div>

    <div class="invite-user-field" *ngIf="details.authentications.length > 1">
      <div class="input-title">
        {{ 'userManagementPage.usersPage.authenticationTitle' | labelsProvider }}
      </div>

      <div class="drop-down-field">
        <app-select
          class="role-field-box"
          [placeHolder]="'userManagementPage.usersPage.authenticationPlaceholder' | labelsProvider"
          [options]="authentications"
          (optionOnSelection)="onAuthenticationSelection($event)"
          [useBeutifyStringProviderPipe]="true"
        >
        </app-select>
      </div>
    </div>
  </div>
  <div class="invite-user-footer">
    <button class="cancel" (click)="onClose()">
      {{ 'common.cancel' | labelsProvider }}
    </button>
    <button
      class="confirm"
      [ngClass]="{
        'confirm-disabled': inviteUserFormGroup.invalid || waitingForResponse,
      }"
      (click)="inviteUser()"
      cdkFocusInitial
    >
      <span *ngIf="!waitingForResponse">{{ 'common.invite' | labelsProvider }}</span>
      <mat-progress-spinner class="spinner" *ngIf="waitingForResponse" color="primary" mode="indeterminate">
      </mat-progress-spinner>
    </button>
  </div>
</div>
